import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Nav, Collapse } from 'react-bootstrap';
import NavbarVerticalMenuItem from './NavbarVerticalMenuItem';
import classNames from 'classnames';
import AppContext from 'context/Context';
import { hasPermission, usePermissionState } from 'helpers/permissionHelper';

function trimSlash(str) {
    if (!str) return str;

    if (str.startsWith("/")) {
        str = str.substring(1);
    }

    if (str.endsWith("/")) {
        str = str.substring(0, str.length - 1);
    }

    return str;
}

const CollapseItems = ({ route }) => {
  const { pathname } = useLocation();
  const permissionState = usePermissionState();

  const openCollapse = childrens => {
    const checkLink = children => {
      if (trimSlash(children.to) === trimSlash(pathname)) {
        return true;
      }
      return (
        Object.prototype.hasOwnProperty.call(children, 'children') &&
        children.children.some(checkLink)
      );
    };
    return childrens.some(checkLink);
  };

  const [open, setOpen] = useState(openCollapse(route.children));

  return hasPermission(route, permissionState) ? (
    <Nav.Item as="li" hidden={route.hidden}>
      <Nav.Link
        onClick={() => {
          setOpen(!open);
        }}
        className={classNames('dropdown-indicator cursor-pointer', {
          'text-500': !route.active
        })}
        aria-expanded={open}
        // {...route}
      >
        <NavbarVerticalMenuItem route={route} />
      </Nav.Link>
      <Collapse in={open}>
        <Nav className="flex-column nav" as="ul">
          <NavbarVerticalMenu routes={route.children} />
        </Nav>
      </Collapse>
    </Nav.Item>
  ) : null;
};

CollapseItems.propTypes = {
  route: PropTypes.shape({
    name: PropTypes.string.isRequired,
    icon: PropTypes.string,
    children: PropTypes.array.isRequired,
    active: PropTypes.bool,
    hidden: PropTypes.bool
  }).isRequired
};

const NavbarVerticalMenu = ({ routes }) => {
  const {
    config: { showBurgerMenu },
    setConfig
  } = useContext(AppContext);
  const permissionState = usePermissionState();
  const handleNavItemClick = () => {
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };

  return routes.map(route => {
    if (!route.children) {
      const isExternal =
        route.to?.startsWith('http://') || route.to?.startsWith('https://');
      return hasPermission(route, permissionState) ? (
        <Nav.Item
          as="li"
          key={route.name}
          onClick={handleNavItemClick}
          hidden={route.hidden}
        >
          <NavLink
            end={route.exact}
            to={route.to}
            state={{ open: route.to === '/authentication-modal' }}
            className={({ isActive }) =>
              !isExternal && isActive ? 'active nav-link' : 'nav-link'
            }
          >
            <NavbarVerticalMenuItem route={route} />
          </NavLink>
        </Nav.Item>
      ) : null;
    }
    return <CollapseItems route={route} key={route.name} />;
  });
};

NavbarVerticalMenu.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape(NavbarVerticalMenuItem.propTypes))
    .isRequired
};

export default NavbarVerticalMenu;
